import { Entity, EntityAspect, EntityType } from 'breeze-client';

export class PortalBaseEntity implements Entity {
    entityAspect: EntityAspect;
    entityType: EntityType;
}
